export const APP_COMPONENT_EVENTS = {
  COMPONENT_ON_MOUNT: "componentOnMount",
  COMPONENT_ON_UNMOUNT: "componentOnUnMount",
  CC_ON_PARAMS_CHANGE: "onCustomComponentParamsChange"
};

export const APP_VARIABLE_TYPE = {
  GLOBAL: "global",
  LOCAL: "local",
  SYSTEM: "system"
};

export const APP_VARIABLE_DATA_TYPES = {
  TEXT: "Text",
  NUMBER: "Number",
  DATETIME: "DateTime",
  BOOLEAN: "Boolean",
  JSON: "Json"
};

export const JSON_SCHEMA_DATA_TYPES = {
  OBJECT: "object",
  ARRAY: "array",
  STRING: "string",
  NUMBER: "number",
  INTEGER: "integer",
  BOOLEAN: "boolean",
  NULL: "null"
};

export const VARIABLE_FIELD_TYPE = {
  ...APP_VARIABLE_DATA_TYPES,
  ARRAY: "Array",
  OBJECT: "Object",
  ROLES: "Roles",
  DEVICE_TYPE: "DeviceType"
};

export const SYSTEM_VARIABLE = {
  DEVICE_TYPE: {
    ID: "device_type",
    LABEL: "Device type"
  },
  CURRENT_USER: {
    ID: "current_user",
    LABEL: "Current user"
  }
};

export const SYSTEM_VARIABLES_ID_MAPPING = {
  [SYSTEM_VARIABLE.DEVICE_TYPE.ID]: SYSTEM_VARIABLE.DEVICE_TYPE.LABEL,
  [SYSTEM_VARIABLE.CURRENT_USER.ID]: SYSTEM_VARIABLE.CURRENT_USER.LABEL
};

export const SYSTEM_VARIABLES_LABEL_MAPPING = {
  [SYSTEM_VARIABLE.CURRENT_USER.LABEL]: SYSTEM_VARIABLE.CURRENT_USER.ID,
  [SYSTEM_VARIABLE.DEVICE_TYPE.LABEL]: SYSTEM_VARIABLE.DEVICE_TYPE.ID
};

export const JSON_SCHEMA_DATA_TYPE_MAPPING = {
  [JSON_SCHEMA_DATA_TYPES.STRING]: VARIABLE_FIELD_TYPE.TEXT,
  [JSON_SCHEMA_DATA_TYPES.INTEGER]: VARIABLE_FIELD_TYPE.NUMBER,
  [JSON_SCHEMA_DATA_TYPES.ARRAY]: VARIABLE_FIELD_TYPE.ARRAY,
  [JSON_SCHEMA_DATA_TYPES.OBJECT]: VARIABLE_FIELD_TYPE.OBJECT,
  [JSON_SCHEMA_DATA_TYPES.BOOLEAN]: VARIABLE_FIELD_TYPE.BOOLEAN
};

export const VARIABLE_DATA_TYPE_MAPPING = {
  [VARIABLE_FIELD_TYPE.TEXT]: JSON_SCHEMA_DATA_TYPES.STRING,
  [VARIABLE_FIELD_TYPE.NUMBER]: JSON_SCHEMA_DATA_TYPES.INTEGER,
  [VARIABLE_FIELD_TYPE.ARRAY]: JSON_SCHEMA_DATA_TYPES.ARRAY,
  [VARIABLE_FIELD_TYPE.OBJECT]: JSON_SCHEMA_DATA_TYPES.OBJECT,
  [VARIABLE_FIELD_TYPE.BOOLEAN]: JSON_SCHEMA_DATA_TYPES.BOOLEAN
};
